var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 95,
    viewBox: "0 0 79 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6482 13.9471C73.6482 13.9471 72.0766 16.6412 69.6071 15.3687C67.1375 14.0962 64.967 12.0756 64.3689 10.5795C63.7699 9.08252 64.1444 6.9129 66.614 7.81092C69.0835 8.70894 72.4511 8.78348 73.6482 8.78348C73.8601 8.78348 74.0882 8.8185 74.3208 8.89483C75.4047 9.25045 76.5937 10.5014 76.7167 13.2736C76.8667 16.6412 78.1383 20.0833 78.1383 20.0833C78.1383 20.0833 78.9618 23.3009 76.7167 25.1724C74.4717 27.0439 72.6756 30.8596 70.2806 33.5536C67.8856 36.2477 68.1101 36.6222 67.961 39.2408C67.811 41.8604 67.2129 48.7446 67.2129 51.7386C67.2129 54.7326 67.6619 61.3178 67.7365 64.3109C67.811 67.304 68.26 70.2981 68.6345 74.0392C69.009 77.7813 69.8316 79.7264 70.0561 80.9989",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5529 81C47.5529 81 48.5784 71.0472 48.6538 67.6042C48.7284 64.1621 49.3273 53.0113 49.4773 50.2427C49.6273 47.4741 49.7764 42.086 50.0009 40.439C50.2254 38.793 49.8509 37.4172 49.3273 36.6081C48.8038 35.7989 46.3342 29.2883 46.1843 24.4991C46.1843 24.4991 46.2588 21.8796 46.1843 21.1315C46.1097 20.3835 45.8098 18.4375 46.1843 17.165C46.5587 15.8925 46.2274 14.1719 47.5529 12.9739C48.8783 11.7768 50.5244 10.8034 52.3205 10.1299C54.1165 9.45633 54.79 11.3269 55.239 12.3749C55.688 13.4229 57.3341 17.1641 57.3341 17.1641C57.3341 17.1641 58.3067 19.6336 56.3616 20.6816C54.4155 21.7296 53.443 20.9807 52.3205 18.7356C51.1979 16.4905 50.5244 16.6405 49.7764 14.9935",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3204 18.7373C52.3204 18.7373 50.7489 19.0363 48.6538 18.7373",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6671 9.98779C53.6671 9.98779 53.5926 6.38851 55.0887 5.34142C56.5848 4.29432 59.9533 4.14435 60.3269 6.31398C60.7013 8.4845 61.6739 14.3216 61.6739 14.3216C61.6739 14.3216 62.6464 18.7372 60.5514 19.3353C58.4563 19.9343 57.6265 17.8509 56.4321 15.1128",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6613 7.59997C67.6613 7.59997 68.1103 2.64737 64.9672 2.04839C61.8242 1.44941 59.8072 3.77169 60.2167 5.92156",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1592 3.97832C67.1592 3.97832 68.0348 0.925942 70.0553 1.00138C72.0759 1.07681 74.2464 2.86477 74.5454 4.77666C74.8445 6.68856 74.32 8.895 74.32 8.895",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6835 14.1897C67.6835 14.1897 68.7835 17.2394 65.3414 18.2128C61.8993 19.1854 61.8086 15.1371 61.8086 15.1371",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2717 15.6255C70.2717 15.6255 70.4881 16.9052 70.2717 18.3636C70.0553 19.8219 70.9533 20.2144 72.5248 20.6634",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9805 74.5391C29.9805 73.4323 29.5898 72.5859 28.8086 72C28.0273 71.401 26.6211 70.776 24.5898 70.125C22.5586 69.4609 20.9505 68.8099 19.7656 68.1719C16.5365 66.4271 14.9219 64.0768 14.9219 61.1211C14.9219 59.5846 15.3516 58.2174 16.2109 57.0195C17.0833 55.8086 18.3268 54.8646 19.9414 54.1875C21.569 53.5104 23.3919 53.1719 25.4102 53.1719C27.4414 53.1719 29.2513 53.543 30.8398 54.2852C32.4284 55.0143 33.6589 56.0495 34.5312 57.3906C35.4167 58.7318 35.8594 60.2552 35.8594 61.9609H30C30 60.6589 29.5898 59.6497 28.7695 58.9336C27.9492 58.2044 26.7969 57.8398 25.3125 57.8398C23.8802 57.8398 22.7669 58.1458 21.9727 58.7578C21.1784 59.3568 20.7812 60.151 20.7812 61.1406C20.7812 62.0651 21.2435 62.8398 22.168 63.4648C23.1055 64.0898 24.4792 64.6758 26.2891 65.2227C29.6224 66.2253 32.0508 67.4688 33.5742 68.9531C35.0977 70.4375 35.8594 72.2865 35.8594 74.5C35.8594 76.9609 34.9284 78.8945 33.0664 80.3008C31.2044 81.694 28.6979 82.3906 25.5469 82.3906C23.3594 82.3906 21.3672 81.9935 19.5703 81.1992C17.7734 80.3919 16.3997 79.2917 15.4492 77.8984C14.5117 76.5052 14.043 74.8906 14.043 73.0547H19.9219C19.9219 76.1927 21.7969 77.7617 25.5469 77.7617C26.9401 77.7617 28.0273 77.4818 28.8086 76.9219C29.5898 76.349 29.9805 75.5547 29.9805 74.5391Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 70.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShand);
export default __webpack_public_path__ + "static/media/Shand.6dec530c3c59bf46d852f497023f3504.svg";
export { ForwardRef as ReactComponent };